import React, { useEffect, useState } from 'react';
import { StyledImage, StyledWrapper } from './style';
import { API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';

const AtresmediaIa = () => {
  const [image, setImage] = useState();
  const [url, setUrl] = useState();
  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'atresmedia_ia') {
          setImage(el.icon);
          setUrl(el.url);
        }
        return image;
      });
    });
  }, []);
  return (
    <StyledWrapper>
      <a
        href={url}
        target="_blank"
        id="atresmedia_ia"
        rel="noopener noreferrer"
      >
        <StyledImage src={image} />
      </a>
    </StyledWrapper>
  );
};

export default AtresmediaIa;
